import { apiProxyRequest } from "Api/apiProxyRequest";
import { ObservabilityPipelineProjectConfiguration } from "Reducers/observability/pipeline";

export const requestObsPipelineConfig = (
  projectId: string,
  environmentId: string
) => {
  const url = `/api/projects/${encodeURIComponent(projectId)}/environments/${encodeURIComponent(
    environmentId
  )}/observability/`;
  return apiProxyRequest<ObservabilityPipelineProjectConfiguration | undefined>(
    url
  );
};
